export default () => {
  const processProgressBars = (root = document) => {
    const progressBars = root.querySelectorAll('.js-block_xp-level-progress');

    if (progressBars.length === 0) return;

    progressBars.forEach((progress) => {
      const fill = progress.querySelector('.js-block_xp-level-progress__fill');
      const text = progress.querySelector('.js-block_xp-level-progress__xp');

      if (!fill || !text) return;

      const fillWidth = fill.clientWidth;
      const textWidth = text.clientWidth + 40;

      if (textWidth > fillWidth) {
        progress.classList.add('block_xp-level-progress--xp-outside');
      } else {
        progress.classList.remove('block_xp-level-progress--xp-outside');
      }
    });
  };

  // Initial run
  processProgressBars();

  // Watch for modal injection
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && node.matches?.('.modal, .modal *')) {
          // Run inside the modal after it's added
          processProgressBars(node);
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};
